import { Box, Spinner, Stack, Text } from "@storyofams/react-ui";
import { createClient } from "@supabase/supabase-js";
import { useQuery } from "react-query";
import { RecipeCard } from "~components/common/RecipeCard";
import { BlogBar } from "~components/common/Story/blocks/BlogBar";

export const RelatedRecipes = ({ category, id, featuredRecipes }) => {
  const supabase = createClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL,
    process.env.NEXT_PUBLIC_SUPABASE_KEY
  );
  const getRecipeItems = async (): Promise<any> => {
    try {
      //@ts-ignore library issue
      const { data } = await supabase
        .rpc("search_recipes_new", {
          search_term: "",
        })
        .eq("recipe_category", category)
        .eq("published", true)
        .neq("id", id)
        .range(0, 3)
        .order("rating", { ascending: false });
      return data;
    } catch (err) {
      console.log(err);
    }
  };
  const { data: recipeItems, isLoading } = useQuery(
    ["getRecipeItems", id],
    getRecipeItems
  );
  return (
    <Box width={"100%"}>
      {featuredRecipes ? (
        <BlogBar
          mb={[0, "20px"]}
          content={{
            recipes_ids: featuredRecipes,
            description: "Probeer ook eens deze recepten.",
            title: "De smaak te pakken?",
            blog_list: [],
          }}
        />
      ) : recipeItems && recipeItems.length ? (
        <Box mb={[0, "20px"]} width={"100%"}>
          <Box mb={3}>
            <Text
              fontFamily={"DINPro"}
              fontSize={["24px", "36px"]}
              fontWeight={700}
              lineHeight={["28.8px", "43.2px"]}
            >
              De smaak te pakken?
            </Text>
            <Text color="#1D1D1BCC" mt={[1.5, 1]} mr={1} fontSize={"18px"}>
              Probeer ook eens deze recepten.
            </Text>
          </Box>
          {isLoading ? (
            <Spinner />
          ) : (
            <Stack
              space={[2, 3]}
              flexDirection={["column", "column", "row"]}
              width="100%"
            >
              {recipeItems.map((item) => (
                <RecipeCard
                  key={item.id}
                  maxWidth={["max-contnet", "307px"]}
                  content={item}
                  mb={[2, 0]}
                />
              ))}
            </Stack>
          )}
        </Box>
      ) : null}
    </Box>
  );
};
